import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const FitnessAiAndroid: React.FC = () => (
  <SEOLandingPage
    title="AI Fitness App for Android — Personalized Workouts & Progress Tracking | Cosmovex"
    metaDescription="FitterAI for Android. AI-powered personalized workout plans, form analysis, progress tracking, and nutrition guidance. Your personal fitness coach on your Android phone."
    ogTitle="FitterAI — AI Fitness & Workout App for Android"
    h1="AI Fitness App for Android"
    intro="Get a personalized AI fitness coach on your Android phone. Customized workout plans, form analysis, progress tracking, and nutrition guidance — all powered by AI and tailored to your goals."
    paragraphs={[
      "Generic workout plans don't work for everyone. Your fitness level, available equipment, schedule, and goals are different from the person next to you. FitterAI uses AI to create a workout plan that actually fits your life — and adjusts it as you progress.",
      "Tell the app your goal (weight loss, muscle gain, strength, endurance), your current fitness level, and what equipment you have access to. FitterAI generates a structured weekly workout plan with exercise selections, sets, reps, and rest periods optimized for your situation. No gym membership required — plans work with bodyweight, dumbbells, resistance bands, or a full gym.",
      "Track every workout with detailed logging. FitterAI records your performance over time and shows progress graphs so you can see your strength and endurance improving week over week. Photo-based form analysis and video demonstrations help you perform exercises correctly, reducing injury risk and maximizing results.",
      "AI-powered nutrition guidance completes the picture. Log your meals, track macros and calories, and get recommendations that support your specific fitness goals. The app learns your patterns over time and refines your plan to keep you making progress without plateaus.",
    ]}
    features={[
      "AI-generated personalized workout plans",
      "Adapts to your fitness level and equipment",
      "Workout logging with progress graphs",
      "Form analysis and video demonstrations",
      "Calorie and macro nutrition tracking",
      "AI nutrition guidance for your goals",
      "Bodyweight, home, and gym workout options",
      "Weekly plan scheduling",
      "Progress photos and measurements",
      "Dark theme for gym use",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.fitterai"
    icon="/images/fitterai.png"
    appName="FitterAI"
    accentColor="#A8720E"
    canonicalPath="/fitness-ai-android"
  />
);

export default FitnessAiAndroid;
